import axios, { AxiosRequestConfig } from 'axios'
import { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import { useQuery } from '@tanstack/react-query'
import { ResponseApiError } from '../../models/axios-error'
import { AggregationLevel, Channel } from './home.model'

export interface GetCumulativeChartsRequest {
  channel: Channel
  aggregation: AggregationLevel
  storeId: number
  teamId: number | null
}

export interface YearlyCumulativeGmvResponse {
  dailyGmvValues: YearlyCumulativeGmvDailyValue[]
}

export interface YearlyCumulativeGmvDailyValue {
  date: string
  realizedGmv?: number
  forecastGmv?: number
  trajectoryGmv: number
}

export interface CumulativeChartItem {
  date: string
  realizedGmv?: number
  forecastGmv?: number
  trajectoryGmv?: number
}

const getYearlyCumulativeGmv = async (config: AxiosRequestConfig): Promise<CumulativeChartItem[]> => {
  const response = await axios<YearlyCumulativeGmvResponse>(config)

  return response.data.dailyGmvValues.map(dailyValue => {
    return {
      date: dailyValue.date,
      realizedGmv: dailyValue.realizedGmv ?? undefined,
      forecastGmv: dailyValue.forecastGmv ?? undefined,
      trajectoryGmv: dailyValue.trajectoryGmv ?? undefined
    }
  })
}

export const useApiGetYearlyCumulativeGmvChartData = (
  request: GetCumulativeChartsRequest,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<CumulativeChartItem[]>
) => {
  const { storeId, teamId, channel, aggregation } = request
  const teamParam = aggregation === 'TEAM' && teamId !== null ? `&teamId=${teamId}` : ''
  const url = `/cumulative-gross-merchandise-value?aggregation=${aggregation}&channel=${channel}&storeId=${storeId}${teamParam}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<CumulativeChartItem[], ResponseApiError>({
    queryKey: ['get-cumulative-gross-merchandise-value', url],
    queryFn: () => getYearlyCumulativeGmv(config),
    enabled,
    ...options
  })
}
